import { DatePipe } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { FiltrosFormatoAsistencialEntity, NodoEntity } from 'src/app/services/servicio-formato-asistencial.service';

@Component({
  selector: 'app-fecha-hora',
  templateUrl: './fecha-hora.component.html',
  styleUrls: ['./fecha-hora.component.css']
})
export class FechaHoraComponent implements OnInit {

  @Input() nodo: NodoEntity;
  @Input() filtros: FiltrosFormatoAsistencialEntity;

  titulo: string;
  valor: string;

  constructor(private datePipe: DatePipe) { }

  ngOnInit() {
    if (this.nodo && this.filtros) {
      this.onProcess();
    } else {
      this.titulo = '';
      this.valor = '';
    }
  }

  onProcess() {
    this.titulo = this.nodo.titulo;
    if (this.nodo.datos && this.nodo.datos.length > 0) {
      const value = Number(this.nodo.datos[0].valor);
      if (value > 0) {
        this.valor = this.datePipe.transform(value, 'dd/MM/yyyy hh:mm a');
      } else {
        this.valor = '--/--/----';
      }
    } else {
      this.valor = '--/--/----';
    }
  }

  onValidateEmptyData(){
    const existData = this.nodo.datos && this.nodo.datos.length > 0;
    if(this.filtros.diligenciados && !existData){
        this.onDelete();
    }
  }

  onDelete(){ }

}
